import { SxProps, Theme } from '@mui/material';

export const displayContentSX = (theme: Theme, isStickyComponent: boolean): SxProps => ({
	padding: isStickyComponent ? '0' : '20px',
	[theme.breakpoints.down('sm')]: {
		padding: isStickyComponent ? '' : '10px',
	},
});

export const containerManufacturerSX = (isStickyComponent: boolean): SxProps<Theme> => ({
	marginBottom: isStickyComponent ? '5px' : '10px',
});

export const manufacturerSX: SxProps<Theme> = {
	display: 'inline-block',
	color: 'secondary.main',
	cursor: 'pointer',
	'&:hover': {
		textDecoration: 'underline',
	},
	'::first-letter': {
		textTransform: 'capitalize',
	},
};

export const productDetailsNameSX = (isStickyComponent: boolean): SxProps<Theme> => ({
	color: 'grey.500',
	marginBottom: isStickyComponent ? '5px' : '10px',
	wordBreak: 'break-word',
	'::first-letter': {
		textTransform: 'capitalize',
	},
});

export const containerMoreTagsSX = (theme: Theme): SxProps => ({
	a: {
		ml: 1,
		color: 'secondary.light',
		textDecoration: 'none',
	},
	'a:hover': {
		textDecoration: 'underline',
	},
	[theme.breakpoints.down('lg')]: {
		flexDirection: 'column',
		alignItems: 'flex-start',
		a: {
			mt: 1,
			ml: 0,
		},
	},
	'[data-bv-show="rating_summary"]': {
		'> .bv_main_container': {
			'> .bv_main_container_row_flex .bv_main_container_row_flex:first-of-type': {
				display: 'none !important',
			},
		},
	},
	'.remove-QA': {
		'> .bv_main_container': {
			'> .bv_main_container_row_flex': {
				pr: '0 !important',
				'.bv_main_container_row_flex:nth-of-type(2)': {
					display: 'none !important',
				},
			},
		},
	},
	'.remove-starts': {
		'.bv_main_container_row_flex.bv_ratings_summary.bv_main_rating_button': {
			display: 'none !important',
		},
	},
});
